import { Injectable } from '@angular/core';
import { CancellationModel, ENDPOINTS, getUuidV4, OdataService } from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OdataCancellationService {
    public constructor(private readonly odataService: OdataService) {}

    public cancelNotification(cancellation: CancellationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            cancellation,
            ENDPOINTS.NotificationCancellation,
            `${cancellation.notification.identifier.toString()}-${getUuidV4()}`,
        );
    }
}
